import { isoZ, z } from 'my-zod'

export const vehicleLocationModel = z.object({
  vehicleId: z.number(),
  positionDate: isoZ.instant(),
  latitude: z.number(),
  longitude: z.number(),
  speed: z.number().describe('A speed in MPH'),
  direction: z.number().describe('A standard compass direction 0-359'),
  heading: z.string().describe('A string such as S, N, SW, etc.')
})

export type vehicleLocationModel = z.infer<typeof vehicleLocationModel>
